export default __webpack_public_path__ + "static/img/test_surroundings_icon.1271e58.svg";